/* eslint-disable @typescript-eslint/no-explicit-any */
import { makeStyles, Persona } from "@fluentui/react-components";
import { Briefcase12Regular } from "@fluentui/react-icons";
import { Case } from "../../data/types"
import { Paths } from "../common";
import { useNavigate } from "react-router";

const useStyles = makeStyles({
    caseControl: {
        cursor: 'pointer'
    },
});

type CaseControlProps = {
    caseObj: Case,
    navToTab?: string;
    noNavToCase?: boolean;
    size?: 'extra-small' | 'small' | 'medium' | 'large';
}
export const CaseControl = (props: CaseControlProps) => {

    const { caseObj, navToTab, noNavToCase = false, size='extra-small' } = props;

    //Hooks
    const navTo = useNavigate();

    //Styles
    const styles = useStyles();

    //UI Events
    const onClick = () => {
        if (!noNavToCase) {
            navTo(Paths.viewEditCase(caseObj.caseId as string), {
                state: {
                    tab: navToTab
                }
            })
        }
    }

    return (
        <Persona
            className={styles.caseControl}
            onClick={onClick}
            name={caseObj.caseName}
            size={size}
            textAlignment='center'
            avatar={{
                badge: { icon: <Briefcase12Regular />, size: 'extra-small' },
                color: "colorful",
                "aria-hidden": true,
                shape: 'circular',
            }}
            data-testid={`case-control-${caseObj.caseId}`}
        />
    )
}